import LineSpacingPanel from './toolbar/LineSpacingPanel';

const Modals = {
  LINE_SPACING: 'LINE_SPACING',
};

const ModalsMap = {
  [Modals.LINE_SPACING]: LineSpacingPanel,
};

export { Modals, ModalsMap };
